// Generated by purs version 0.15.15
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_Models_Brands_ErrorInfoText from "../Ouroboros.Models.Brands.ErrorInfoText/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Brands_HttpStatusCode from "../Ouroboros.Models.Brands.HttpStatusCode/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var show1 = /* #__PURE__ */ Data_Show.show(Data_Show.showNumber);
var messageText = Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText;
var infoText = Ouroboros_Models_Brands_ErrorInfoText.makeErrorInfoText;
var formatStatusCode = function (code) {
    var v = Data_Int.fromNumber(Ouroboros_Models_Brands_HttpStatusCode.unwrap(code));
    if (v instanceof Data_Maybe.Just) {
        return show(v.value0);
    };
    if (v instanceof Data_Maybe.Nothing) {
        return show1(Ouroboros_Models_Brands_HttpStatusCode.unwrap(code));
    };
    throw new Error("Failed pattern match at Ouroboros.Models.Core.Errors (line 58, column 3 - line 60, column 49): " + [ v.constructor.name ]);
};
var statusCodeInfo = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe)(function (code) {
    return infoText("Status code: " + formatStatusCode(code));
});
var appendMessage = function (prefix) {
    return function (err) {
        return messageText(prefix + Ouroboros_Models_Brands_ErrorMessageText.unwrap(err));
    };
};
var authenticationErrorMessage = function (err) {
    if (err.type === "Unauthorized") {
        return {
            message: messageText("Invalid credentials. Please try again."),
            info: Data_Maybe.Nothing.value
        };
    };
    if (err.type === "NetworkError") {
        return {
            message: messageText("Network error. Please check your internet connection."),
            info: Data_Maybe.Nothing.value
        };
    };
    if (err.type === "ValidationError") {
        return {
            message: messageText("The response from the server could not be read. Please refresh your browser or contact support."),
            info: Data_Maybe.Nothing.value
        };
    };
    if (err.type === "ServerError") {
        return {
            message: appendMessage("Server error: ")(err.message),
            info: statusCodeInfo(err.statusCode)
        };
    };
    if (err.type === "ExistingAccountError") {
        return {
            message: messageText("An account already exists for this email."),
            info: Data_Maybe.Nothing.value
        };
    };
    return {
        message: messageText("An unknown error occurred while authenticating. Please try again."),
        info: Data_Maybe.Nothing.value
    };
};
var contentErrorMessage = function (err) {
    if (err.type === "Unauthorized") {
        return {
            message: messageText("Unauthorized action. Please check your credentials."),
            info: Data_Maybe.Nothing.value
        };
    };
    if (err.type === "NetworkError") {
        return {
            message: messageText("Network error. Please check your internet connection."),
            info: Data_Maybe.Nothing.value
        };
    };
    if (err.type === "ValidationError") {
        return {
            message: messageText("The response from the server could not be read, please update your app or refresh your web browser. If the problem persists, contact support."),
            info: Data_Maybe.Nothing.value
        };
    };
    if (err.type === "ServerError") {
        return {
            message: appendMessage("Server error: ")(err.message),
            info: statusCodeInfo(err.statusCode)
        };
    };
    return {
        message: messageText("An unknown error occurred. Please try again."),
        info: Data_Maybe.Nothing.value
    };
};
var feedbackErrorMessage = function (err) {
    if (err.type === "Unauthorized") {
        return {
            message: messageText("Unauthorized action. Please check your credentials."),
            info: Data_Maybe.Nothing.value
        };
    };
    if (err.type === "NetworkError") {
        return {
            message: messageText("Network error. Please check your internet connection."),
            info: Data_Maybe.Nothing.value
        };
    };
    if (err.type === "ValidationError") {
        return {
            message: messageText("The response from the server could not be read. Please refresh your browser or contact support."),
            info: Data_Maybe.Nothing.value
        };
    };
    if (err.type === "ServerError") {
        return {
            message: appendMessage("Server error: ")(err.message),
            info: statusCodeInfo(err.statusCode)
        };
    };
    if (err.type === "FeedbackNotFound") {
        return {
            message: (function () {
                var $11 = Ouroboros_Models_Brands_ErrorMessageText.unwrap(err.message) === "";
                if ($11) {
                    return messageText("Feedback not found. Please try again.");
                };
                return messageText("Feedback not found for ID: " + (Ouroboros_Models_Brands_ErrorMessageText.unwrap(err.message) + ". Please try again or contact support."));
            })(),
            info: Data_Maybe.Nothing.value
        };
    };
    return {
        message: messageText("An unknown error occurred. Please try again."),
        info: Data_Maybe.Nothing.value
    };
};
var lifecycleErrorMessage = function (err) {
    if (err.type === "Unauthorized") {
        return {
            message: messageText("Unauthorized action. Please check your credentials."),
            info: Data_Maybe.Nothing.value
        };
    };
    if (err.type === "NetworkError") {
        return {
            message: messageText("Network error. Please check your internet connection."),
            info: Data_Maybe.Nothing.value
        };
    };
    if (err.type === "ValidationError") {
        return {
            message: messageText("The response from the server could not be read. Please refresh your browser or contact support."),
            info: Data_Maybe.Nothing.value
        };
    };
    if (err.type === "ServerError") {
        return {
            message: appendMessage("Server error: ")(err.message),
            info: statusCodeInfo(err.statusCode)
        };
    };
    if (err.type === "DownloadError") {
        return {
            message: (function () {
                var $13 = Ouroboros_Models_Brands_ErrorMessageText.unwrap(err.message) === "";
                if ($13) {
                    return messageText("Unable to download document. Please try again.");
                };
                return messageText("Unable to download document. " + Ouroboros_Models_Brands_ErrorMessageText.unwrap(err.message));
            })(),
            info: Data_Maybe.Nothing.value
        };
    };
    return {
        message: messageText("An unknown error occurred while fetching document data. Please try again."),
        info: Data_Maybe.Nothing.value
    };
};
var passwordResetErrorMessage = function (err) {
    if (err.type === "NetworkError") {
        return {
            message: messageText("Network error. Please check your internet connection."),
            info: Data_Maybe.Nothing.value
        };
    };
    if (err.type === "ValidationError") {
        return {
            message: messageText("The response from the server could not be read. Please refresh your browser or contact support."),
            info: Data_Maybe.Nothing.value
        };
    };
    if (err.type === "ServerError") {
        return {
            message: appendMessage("Server error: ")(err.message),
            info: statusCodeInfo(err.statusCode)
        };
    };
    if (err.type === "TokenInvalid") {
        return {
            message: messageText("This reset link is invalid. Please request a new one."),
            info: Data_Maybe.Nothing.value
        };
    };
    if (err.type === "TokenExpired") {
        return {
            message: messageText("This reset link has expired. Please request a new one."),
            info: Data_Maybe.Nothing.value
        };
    };
    if (err.type === "TokenConsumed") {
        return {
            message: messageText("This reset link has already been used. Please request a new one."),
            info: Data_Maybe.Nothing.value
        };
    };
    return {
        message: messageText("An unknown error occurred. Please try again."),
        info: Data_Maybe.Nothing.value
    };
};
var paymentErrorMessage = function (err) {
    if (err.type === "Unauthorized") {
        return {
            message: messageText("Unauthorized action. Please check your credentials."),
            info: Data_Maybe.Nothing.value
        };
    };
    if (err.type === "NetworkError") {
        return {
            message: messageText("Network error. Please check your internet connection."),
            info: Data_Maybe.Nothing.value
        };
    };
    if (err.type === "ValidationError") {
        return {
            message: (function () {
                var $16 = Ouroboros_Models_Brands_ErrorMessageText.unwrap(err.message) === "";
                if ($16) {
                    return messageText("The response from the server could not be read. Please refresh your browser or contact support.");
                };
                return err.message;
            })(),
            info: Data_Maybe.Nothing.value
        };
    };
    if (err.type === "ServerError") {
        return {
            message: appendMessage("Server error: ")(err.message),
            info: statusCodeInfo(err.statusCode)
        };
    };
    return {
        message: messageText("An unknown error occurred. Please try again."),
        info: Data_Maybe.Nothing.value
    };
};
var accountErrorMessage = function (err) {
    if (err.type === "Unauthorized") {
        return {
            message: messageText("Unauthorized action. Please check your credentials."),
            info: Data_Maybe.Nothing.value
        };
    };
    if (err.type === "NetworkError") {
        return {
            message: messageText("Network error. Please check your internet connection."),
            info: Data_Maybe.Nothing.value
        };
    };
    if (err.type === "ValidationError") {
        return {
            message: messageText("The account data could not be validated. Please contact support."),
            info: Data_Maybe.Nothing.value
        };
    };
    if (err.type === "ServerError") {
        return {
            message: appendMessage("Server error: ")(err.message),
            info: statusCodeInfo(err.statusCode)
        };
    };
    if (err.type === "AccountNotFound") {
        return {
            message: messageText("Account not found. Please try again or contact support."),
            info: Data_Maybe.Nothing.value
        };
    };
    return {
        message: messageText("An unknown error occurred while fetching account details. Please try again."),
        info: Data_Maybe.Nothing.value
    };
};
export {
    accountErrorMessage,
    authenticationErrorMessage,
    contentErrorMessage,
    feedbackErrorMessage,
    lifecycleErrorMessage,
    passwordResetErrorMessage,
    paymentErrorMessage
};
//# sourceMappingURL=index.js.map
